import { useState } from 'react';
import { rem } from '../lib/fontSize';

/**
 * Logo client : essaie /logos/<id>.png (servi en preprod depuis /web/logos/
 * bind-mounté). Fallback : capsule texte avec les initiales.
 */
export function ClientLogo({
  id,
  name,
  size = 24,
}: {
  id: number | null | undefined;
  name: string | null | undefined;
  size?: number;
}) {
  const [failed, setFailed] = useState(false);
  const label = name ?? '';
  const initials =
    label
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase() || '?';

  if (!id || failed) {
    return (
      <span
        title={label}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: rem(size),
          height: rem(size),
          fontSize: rem(size * 0.4),
          lineHeight: 1,
          fontWeight: 700,
          color: 'var(--text-mute)',
          background: 'var(--bg-soft)',
          border: '1px solid var(--border)',
          borderRadius: 4,
          flexShrink: 0,
        }}
      >
        {initials}
      </span>
    );
  }
  return (
    <img
      src={`/logos/${id}.png`}
      alt={label}
      title={label}
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
      style={{
        width: rem(size),
        height: rem(size),
        objectFit: 'contain',
        background: 'white',
        border: '1px solid var(--border)',
        borderRadius: 4,
        flexShrink: 0,
      }}
    />
  );
}
